import { Api } from "@/services/Api";
import { IHotel, hotelDetails } from "./index";
import hasha from "hasha";
import storage from "@/storage/storage";
import { Hotel } from "@/models/Hotel";

const HOTEL_BASE_URL = "/hotel/0/dto/hotel/v1";

const resetCacheData = async (url: string): Promise<void> => {
  const rawKey = `${url}get`;
  const hashKey = await hasha.async(rawKey, { algorithm: "sha1" });
  await storage.removeItem(hashKey);
};

const fetchMasterData = async ({ commit }): Promise<void> => {
  try {
    const hotelChain = await Api.get("/hotel/0/dto/hotel-chain/v1");
    const hotelCategory = await Api.get("/hotel/0/dto/hotel-category/v1");
    const currencies = await Api.get("/hotel/0/dto/currency/v1");
    commit("SET_HOTEL_CHAINS", hotelChain.data.Data || []);
    commit("SET_CURRENCIES", currencies.data.Data || []);
    commit("SET_HOTEL_CATEGORY", hotelCategory.data.Data || []);
  } catch (err) {
    commit("SET_HOTEL_CHAINS", []);
    commit("SET_CURRENCIES", []);
    commit("SET_HOTEL_CATEGORY", []);
  }
};

const setHotelDetail = ({ commit }, obj: IHotel) => {
  commit("SET_HOTEL_DETAILS", obj);
};

const fetchHotelDetails = async ({ commit }, id: number) => {
  try {
    if (!id) {
      throw "Invalid hotel ID!";
    }

    const url = `/hotel/${id}/dto/hotel/v1`;
    const obj = await Api.get(`${url}?id=${id}`);
    if (obj.data.Data.length >= 0) {
      commit("SET_HOTEL_DETAILS", obj.data.Data[0]);
    } else {
      throw `Hotel with id ${id} not found!`;
    }
  } catch (err) {
    commit("SET_HOTEL_DETAILS", {});
  }
};

const deleteHotel = async ({ commit, dispatch }, id: number) => {
  commit("SET_LOADING_START");
  try {
    await Api.del(`${HOTEL_BASE_URL}?id=${id}`);
    await resetCacheData(HOTEL_BASE_URL);
    commit("SET_SNACKBAR_STATUS", "success");
    commit("SET_SNACKBAR_VISIBILITY", true);
    commit("SET_SNACKBAR_MESSAGE", "Successfully Delete Hotel");
  } catch (e: any) {
    commit("SET_SNACKBAR_STATUS", "error");
    commit("SET_SNACKBAR_VISIBILITY", true);
    commit("SET_SNACKBAR_MESSAGE", e?.response?.data?.Data || e?.message || "Failed to delete hotel");
  }
  commit("SET_LOADING_FINISHED");
};

const clearHotelData = ({ commit }): void => {
  const data = hotelDetails();
  commit("CLEAR_HOTEL_DATA", data);
};

const closeSnackbar = ({ commit }): void => {
  commit("CLEAR_SNACKBAR");
};

const handleFileSelect = ({ commit }, file: File) => {
  const obj = {
    fileName: file.name,
    imgUrl: URL.createObjectURL(file),
  };
  commit("SET_SELECTED_FILE", obj);
};

const handleRemoveFile = ({ commit }) => {
  commit("CLEAR_SELECTED_FILE");
};

export default {
  fetchMasterData,
  fetchHotelDetails,
  setHotelDetail,
  deleteHotel,
  clearHotelData,
  handleFileSelect,
  handleRemoveFile,
  closeSnackbar,
};
